"use strict";
exports.__esModule = true;
exports.usePaymentFees = exports.getProcessingFeesFromPricing = exports.getProcessingFeePercentage = void 0;
var types_1 = require("./types");
var getProcessingFeePercentage = function (paymentMethodType, pricingOffer) {
    var processingFeeBips = 0;
    switch (paymentMethodType) {
        case types_1.PaymentMethodType.CREDIT:
            processingFeeBips = pricingOffer === null || pricingOffer === void 0 ? void 0 : pricingOffer.credit_card_fee_bips;
            break;
        case types_1.PaymentMethodType.DEBIT:
            processingFeeBips = pricingOffer === null || pricingOffer === void 0 ? void 0 : pricingOffer.debit_card_fee_bips;
            break;
    }
    return processingFeeBips / 100;
};
exports.getProcessingFeePercentage = getProcessingFeePercentage;
var getProcessingFeesFromPricing = function (pricingOffer) {
    var _a, _b;
    if (!pricingOffer) {
        return _a = {},
            _a[types_1.PaymentMethodType.CREDIT] = 0,
            _a[types_1.PaymentMethodType.DEBIT] = 0,
            _a;
    }
    return _b = {},
        _b[types_1.PaymentMethodType.CREDIT] = (0, exports.getProcessingFeePercentage)(types_1.PaymentMethodType.CREDIT, pricingOffer),
        _b[types_1.PaymentMethodType.DEBIT] = (0, exports.getProcessingFeePercentage)(types_1.PaymentMethodType.DEBIT, pricingOffer),
        _b;
};
exports.getProcessingFeesFromPricing = getProcessingFeesFromPricing;
var usePaymentFees = function (pricingOffer) {
    if (!pricingOffer) {
        return {
            billPaymentFeePercent: 0,
            debitCardFeePercent: 0,
            creditCardFeePercent: 0
        };
    }
    var billPaymentFeePercent = (0, exports.getProcessingFeePercentage)(types_1.PaymentMethodType.DEBIT, pricingOffer);
    var creditCardFeePercent = Math.max((0, exports.getProcessingFeePercentage)(types_1.PaymentMethodType.CREDIT, pricingOffer) - billPaymentFeePercent, 0);
    return {
        billPaymentFeePercent: billPaymentFeePercent,
        debitCardFeePercent: 0,
        creditCardFeePercent: creditCardFeePercent
    };
};
exports.usePaymentFees = usePaymentFees;
